// new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(number))

import { NoRecordField } from "../NoRecordField";

export const FormatCurrency = (amount) => {
  if (!amount) {
    return NoRecordField(amount);
  }
  const fixAmount = amount.toFixed(2);
  const formatter = new Intl.NumberFormat(navigator.language, {
    style: "currency",
    minimumFractionDigits: 0,
    currency: "IDR",
  });
  return formatter.format(fixAmount);
};
